import { ICategoricalChartOptions } from '..';
import { CategoricalChartData } from './CategoricalChart.model';
import { SeriesFormat } from './SeriesFormat';
import { defaultFormat } from '../defaultDataFormat';
import { StepMode } from '../../../models/StepMode';

/**
 * Maps series and data to representable format according to options.
 * @param series The list of series.
 * @param data The list of data.
 * @param options The chart options.
 */
export function map(series: SeriesFormat[], data: any[], options: ICategoricalChartOptions): CategoricalChartData[] {
    let topOfPrevious = 0;
    let steppedMax = 0;
    let steppedMin = 0;
    const result: CategoricalChartData[] = series
        .map(s => {
            const { dataFormat } = options;
            const { value, identifier, label } = dataFormat;
            const { min, max } = s;
            const id = identifier(s);
            const currentData = data.filter(d => identifier(d) === id);
            let v = currentData && currentData.length ? value(currentData[0]) : null;
            if (isNaN(v)) {
                v = null;
            }
            const hasMin = s.displayMin && min !== undefined && min !== null;
            const hasMax = s.displayMax && max !== undefined && max !== null;
            const rawColor = s.color || options.color;
            const isOutOfRange = (v || v === 0) && (hasMin && v < min) || (hasMax && v > max);
            const format = s.format || defaultFormat;
            const formattedValue: string = (!v && v !== 0) ? format(v).replace('0.00', 'NaN') : format(v);
            const classes = [];
            if (isOutOfRange) {
                classes.push('fill-error');
            }
            let offset: number;
            switch (s.stepMode) {
                case StepMode.plus:
                    offset = topOfPrevious;
                    topOfPrevious += v;
                    break;
                case StepMode.minus:
                    offset = topOfPrevious - v;
                    topOfPrevious -= v;
                    break;
                case StepMode.nothing:
                default:
                    offset = 0;
                    topOfPrevious = v;
                    break;
            }
            steppedMin = Math.min(steppedMin, topOfPrevious);
            steppedMax = Math.max(steppedMax, topOfPrevious);
            const r: CategoricalChartData = {
                id,
                label: label(s),
                value: v,
                formattedValue: formattedValue,
                color: rawColor,
                labelColor: rawColor,
                attributes: s.attributes,
                clickCallback: s.clickCallback,
                classes,
                hasMin,
                min,
                hasMax,
                max,
                offset,
                steppedMax,
                steppedMin
            };
            return r;
        });
    return result;
}